import Blazy from 'blazy'
import Store from 'core/Store'

const blazy = new Blazy()

function ImageGrid () {
  const images = JSON.parse(JSON.stringify(window.images))
  const $ = document.querySelector('.home-gallery')
  const $container = document.querySelector('.home-gallery > ul')
  const $description = document.querySelector('.home-description')
  const $indicator = document.querySelector('.gallery-indicator')
  const $focusOverlay = document.querySelector('.overlay-focus')
  const $focusImage = $focusOverlay.querySelector('.focus-image')
  const $focusCaption = $focusOverlay.querySelector('.focus-caption')
  const $focusClose = $focusOverlay.querySelector('.focus-close')
  const size = { w: 0, h: 0 }

  let height = 0
  let populated = false

  onResize(Store.get('size'))
  Store.watch('size', onResize)
  Store.watch('scroll', onScroll)

  Store.watch('env', () => {
    $indicator.classList.remove('hidden')
  })

  $focusClose.addEventListener('click', closeFocus)
  $focusOverlay.addEventListener('click', closeFocus)

  $.addEventListener('scroll', (e) => {
    const progress = e.target.scrollLeft
    if (progress > 100) $indicator.classList.add('hidden')
    else $indicator.classList.remove('hidden')
    blazy.revalidate()
  })

  setInterval(() => blazy.revalidate(), 2000)

  function onResize (nSize) {
    size.w = nSize.w
    size.h = nSize.h

    const top = $container.getBoundingClientRect().top
    const bottom = $description.getBoundingClientRect().top
    height = (Store.get('env') === 'desktop')
      ? bottom - top - 30
      : (size.w < size.h ? size.w * 0.7 : size.h * 0.5)

    $container.style.height = height + 'px'

    if (!populated) populate()
    else updateLayout()
  }

  function onScroll (scroll) {
    $container.style.left = -scroll + 'px'
  }

  function focusImage (url, caption) {
    $focusImage.style.backgroundImage = 'url(' + url + ')'
    $focusCaption.innerHTML = caption
    $focusOverlay.classList.add('visible')
    document.body.style.overflow = 'hidden'
  }

  function closeFocus (e) {
    e.preventDefault()
    e.stopPropagation()
    $focusOverlay.classList.remove('visible')
    document.body.style.overflow = ''
  }

  function populate () {
    populated = true

    images.forEach((image) => {
      const $li = document.createElement('li')
      const $img = document.createElement('img')
      $img.classList.add('b-lazy')
      $img.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      $img.dataset.src = image.url
      $li.classList.add('gallery-container')
      image.container = $li
      image.source = $img
      $li.appendChild($img)
      $container.appendChild($li)
      $li.addEventListener('click', () => focusImage(image.bigUrl, image.caption))
    })
    updateLayout()
    setTimeout(() => blazy.revalidate(), 100)
    setTimeout(() => blazy.revalidate(), 500)
  }

  function updateLayout () {
    images.forEach((image) => {
      let offsetheight = height
      if (image.orientation === 'portrait') {
        offsetheight = height
        image.container.style['margin-top'] = ''
      } else if (image.orientation === 'landscape') {
        offsetheight = height - 40
        image.container.style['margin-top'] = ''
      }

      const ratio = offsetheight / image.height
      image.container.style.height = offsetheight + 'px'
      image.container.style.width = +(image.width * ratio) + 'px'
    })

    if (Store.get('env') === 'desktop') document.body.style.height = +(size.h + $container.offsetWidth - size.w + 30) + 'px'
    else document.body.style.height = ''
    setTimeout(() => blazy.revalidate(), 10)
  }
}

export default ImageGrid



// WEBPACK FOOTER //
// ./src/js/components/ImageGrid.js